import React from 'react'

import { colors } from 'helpers/colors'

const SvgCrossMarkOutlineV2 = ({ size = 30, color = colors.gray[700] }) => {
  return (
    <svg width={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.201089 0.201089C0.469207 -0.0670294 0.903912 -0.0670296 1.17203 0.201089L7 6.02906L12.828 0.201089C13.0961 -0.0670289 13.5308 -0.0670289 13.7989 0.201089C14.067 0.469207 14.067 0.903912 13.7989 1.17203L7.97094 7L13.7989 12.828C14.067 13.0961 14.067 13.5308 13.7989 13.7989C13.5308 14.067 13.0961 14.067 12.828 13.7989L7 7.97094L1.17203 13.7989C0.903911 14.067 0.469206 14.067 0.201089 13.7989C-0.0670293 13.5308 -0.0670299 13.0961 0.201089 12.828L6.02906 7L0.201089 1.17203C-0.067029 0.90391 -0.0670288 0.469207 0.201089 0.201089Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCrossMarkOutlineV2
